import { AccordionRoot } from "./Root";
import { AccordionListHeader } from "./ListHeader";
import { AccordionSectionHeader } from "./SectionHeader";
import {
  Item,
  Content,
  Title,
  FakeLabel,
  Header,
  ListHeaderLayout,
  ListContent,
  ListItem,
  ListCheckboxItem,
  Divider,
  Trigger,
  Chevron
} from "./Accordion.styles";

// Export types
export type { AccordionRootProps } from "./Root";
export type { AccordionListHeaderProps } from "./ListHeader";
export type { AccordionSectionHeaderProps } from "./SectionHeader";

// Export main components
export { AccordionRoot, AccordionListHeader, AccordionSectionHeader };

// Export styled components
export {
  Item,
  Content,
  Title,
  FakeLabel,
  Header,
  ListHeaderLayout,
  ListContent,
  ListItem,
  ListCheckboxItem,
  Divider,
  Trigger,
  Chevron
};

// Export a namespace for consistent usage pattern
export const Accordion = {
  Root: AccordionRoot,
  Item,
  Content,
  SectionHeader: AccordionSectionHeader,
  ListHeader: AccordionListHeader,
  ListContent,
  ListItem,
  ListCheckboxItem
};
